<template>
    <div class="spinner-overlay-component">
      <spinner />
    </div>
  </template>
    
  <script>
import { ref, computed, watch } from 'vue'
import Spinner from './Spinner.vue';
  
export default {
  components: { Spinner },
  props: {
  },
  setup(props,{emit}) {
      return {
      };
  }
}
</script>

<style lang="scss" scoped>
.spinner-overlay-component {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>